import { AboutUSData } from './type'
import { GlobalService } from '@/context'

/**
 * 获取关于我们
 */
export const apiGetAboutUsInfo = () => {
  return GlobalService.get<Array<AboutUSData>>({
    url: '/api/lobby/aboutUs/index/getInfo',
    customParams: {
      noEncrypt: true,
      tryStaticMode: true,
      cache: true,
      staticKeyOmit: ['currency', 'platformType']
    }
  })
}
